module.exports = __webpack_public_path__ + "media/4tentative.da7df7bf.mp3";